import { useEffect, useRef } from 'react';

// Focus and Escape for the hand-rolled overlays in this folder. A dialog that
// announces itself as one has to be reachable and dismissable from the keyboard:
// focus moves in on open, Escape closes, and whatever opened it gets focus back.
//
// Pass a stable `onClose` (a useState setter, or a useCallback) — an identity that
// changes every render would re-run this and pull focus out from under whoever is
// typing. Spread the returned props onto the dialog's own element, not the scrim.
export function useModalDismiss(onClose: () => void) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const prev = document.activeElement as HTMLElement | null;
    ref.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('keydown', onKey);
      prev?.focus?.();
    };
  }, [onClose]);

  return { ref, tabIndex: -1, role: 'dialog', 'aria-modal': true } as const;
}
